import { render, staticRenderFns } from "./AscRoleDialogGridTemplate.vue?vue&type=template&id=89229420&"
import script from "./AscRoleDialogGridTemplate.vue?vue&type=script&lang=js&"
export * from "./AscRoleDialogGridTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports